import { Component, ElementRef, Inject, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { DialogBaseComponent } from '../dialogs/dialog-base/dialog-base.component';
import { DatePipe } from '@angular/common';
import { CustomValidators } from 'src/app/util/custom-validators';
import { EmpresaResult } from 'src/app/models/mandatos-express/empresa-result';
import { ListPacParametroPeticion } from 'src/app/models/mandatos-express/listPacParametroPeticion';
import { InscribirMandatosModel } from 'src/app/models/mandatos-express/addMandato';
import { BuscarImagenBoleta } from 'src/app/models/mandatos-express/buscarImagenBoleta';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Ciudad } from 'src/app/models/mandatos-express/ciudad';
import { MandatosExpressService } from 'src/app/services/mandatos-express.service';
import { LoaderBaseService } from 'src/app/services/loader-base.service';
import { RubroRequest } from 'src/app/models/mandatos-express/rubro-request';
import { TerminoCondiciones } from 'src/app/models/mandatos-express/condiciones';
import { TerminoCondicionesFinal } from 'src/app/models/mandatos-express/condicionesFinal';
import { RubroResult } from 'src/app/models/mandatos-express/rubro-result';
import { EmpresasPeticion } from 'src/app/models/mandatos-express/empresasPeticion';
import { MediosPago } from 'src/app/models/mandatos-express/mediosPago';
import { InscribirMandatoResponse } from 'src/app/models/mandatos-express/addMandatoResponse';
import { Estilos } from 'src/app/services/estilos/estilos';
import { CardinalCommerceService } from 'src/app/services/cardinal-commerce/cardinal-commerce.service';
import { ValidationPanParams } from 'src/app/models/mandatos-express/validation-trx-params';
import { ValidationPanResponse } from 'src/app/models/mandatos-express/validation-trx-response';
import { CondicionesGeneralesComponent } from '../dialogs/condiciones-generales/condiciones-generales.component';
import { MatHorizontalStepper } from '@angular/material';
import { AutenticadorService } from 'src/app/services/autenticador/autenticador.service';
import { PreLoginPeticion } from 'src/app/models/pre-login/PreLogin-peticion';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Embebido } from 'src/app/models/mandatos-express/apiEmbebidoPeticion';
import { ServiciosComercio } from 'src/app/models/mandatos-express/serviciosComercio';
import { ListPeticionEmbebido } from 'src/app/models/mandatos-express/listPeticionEmbebido';
import { ValidaSesionPeticion } from 'src/app/models/mandatos-express/validasesionpeticion';
import { PlaceToPayService } from 'src/app/services/place-to-pay/place-to-pay.service';
import { ConsultaBinResponse } from 'src/app/models/mandatos-express/consulta-bin-response';
import { ConsultaBinParams } from 'src/app/models/mandatos-express/consulta-bin-params';
import { PlaceToPayGetTransaResponse, PlaceToPayPeticion, PlaceToPayResponse } from 'src/app/models/mandatos-express/placeToPay';
import { DialogPlace2payComponent } from '../dialogs/dialog-place-2-pay/dialog-place-2-pay.component';
import { NumberMonedasStr } from 'src/app/util/currency.pipe';


declare function setupCardinalCommerce(): any;
declare function validatePayment(accountNumber: string, expirationMonth: string, expirationYear: string, cardCode: string, orderNumber: string, jWTContainer: string): any;

@Component({
  selector: 'app-add-mandatos-express',
  templateUrl: './add-mandatos-express.component.html',
  styleUrls: ['./add-mandatos-express.component.css'],
  providers: [MandatosExpressService, CardinalCommerceService, LoaderBaseService, DatePipe, AutenticadorService, PlaceToPayService]
})
export class AddMandatosExpressComponent implements OnInit {
  lengthMontoPorMoneda: number = 13;
  firstFormGroup: FormGroup = new FormGroup({
    rutSuscriptor: new FormControl('', Validators.compose([CustomValidators.validatorCedulaUY, Validators.required])),
    nombreSuscriptor: new FormControl('', Validators.compose([Validators.required, CustomValidators.nameValidator])),
    apellidoA: new FormControl('', Validators.compose([Validators.required, CustomValidators.nameValidator])),
    apellidoB: new FormControl('', CustomValidators.nameValidator),
    idRubro: new FormControl('', Validators.required),
    idEmpresa: new FormControl({ value: '', disabled: true }, Validators.required),
    diaPago: new FormControl('', Validators.required),
    idServicio: new FormControl({ value: '', disabled: true }, Validators.compose([Validators.required, CustomValidators.idServiceValidator])),
    servicioAlias: new FormControl('', Validators.compose([Validators.required, CustomValidators.descriptionValidator])),
    medioPago: new FormControl('', Validators.compose([Validators.required, CustomValidators.cardNumberValidator, Validators.minLength(15), Validators.maxLength(19), CustomValidators.numberValidator])),
    mesMedioPago: new FormControl('', Validators.compose([Validators.required])),
    anioMedioPago: new FormControl('', Validators.required),
    codSeg: new FormControl('', Validators.compose([CustomValidators.numberValidator, Validators.maxLength(4)])),
    medioPagoMontoMax: new FormControl({ value: '', disabled: true }, Validators.compose([Validators.maxLength(this.lengthMontoPorMoneda), CustomValidators.amountValidator])),
    montofijo: new FormControl({ value: '', disabled: true }, Validators.compose([Validators.required, Validators.maxLength(this.lengthMontoPorMoneda), CustomValidators.amountValidator])),
    contactoEmail: new FormControl('', Validators.compose([Validators.required, CustomValidators.validaEmail])),
    notificacionEmail: new FormControl(false, Validators.required),
    // codfijo: new FormControl('', Validators.compose([Validators.maxLength(2)])),
    // contactoFijo: new FormControl('', Validators.minLength(8)),
    codmovil: new FormControl('', Validators.compose([CustomValidators.numberValidator, Validators.maxLength(3)])),
    contactoMovil: new FormControl('', Validators.compose([CustomValidators.numberValidator, Validators.minLength(8)])),
    contactoDireccion: new FormControl('', CustomValidators.descriptionValidator),
    contactoCiudad: new FormControl(''),
    medioPagoAdquirente: new FormControl('', Validators.required),
    servicioComercio: new FormControl('', Validators.required),
    nombrePromotor: new FormControl('', Validators.compose([CustomValidators.descriptionValidator, Validators.maxLength(300)]))
  }, CustomValidators.validaMes);

  confirmacionForm = new FormGroup({
    declaracion: new FormControl(false, Validators.required)
  });

  idSesion: string = '';
  ambiente: string;
  urlSalida: string = '';
  imagenBoleta: string;
  numeroFijoCompleto: string;
  numeroMovilCompleto: string;
  formatoImagenBoleta: string;
  imgtarjeta: string= '';
  cardBrand: string = '';
  tipoCobro = 'V';
  idFac: string = "";
  orderNumber: string = "";
  jWTContainer: string = "";
  etiquetaPromotor: string = "";
  placeHolderPromotor: string = "";
  rubroSelectedOptiontText: string = "";
  empresaSelectedOptiontText: string = "";
  ciudadSelectedOptiontText: string = "";

  isLinear: boolean = false;
  esComercio: boolean = false;
  isEditable: boolean = true;
  isEmbebido: boolean = false;
  isCompleted: boolean = false;
  tieneImagen: boolean = false;
  nuevaImagen: boolean = false;
  esAdquirente: boolean = false;
  utilizaPromotor: boolean = false;
  idConvenioSelected: string = '';
  transactionID: number;
  monedaPago: string;

  datosApi: any;
  idUsuario: any;
  userPerfil: any;
  base64Image: SafeResourceUrl;
  resultadoListPacParametro: any;
  preLoginsLS: { codTpoPortal: string; };

  mandato = new InscribirMandatosModel();
  estilos : Estilos = new Estilos();
  sesionId: ListPeticionEmbebido = new ListPeticionEmbebido();
  dateNow: Date = new Date();
  embebido: Embebido = new Embebido();
  respuesta: InscribirMandatoResponse = new InscribirMandatoResponse('', '', '');
  buscarImagen: BuscarImagenBoleta = new BuscarImagenBoleta();
  peticionEmpresa = new EmpresasPeticion();
  terminoCond : TerminoCondiciones = new TerminoCondiciones();
  peticionSesion: ValidaSesionPeticion = new ValidaSesionPeticion();
  terminoCondFinal : TerminoCondicionesFinal = new TerminoCondicionesFinal();
  validatePanParams: ValidationPanParams = new ValidationPanParams();
  peticionListPacParametro = new ListPacParametroPeticion();

  servicios:Array<any> = [];
  arrayCiudades: Array<Ciudad> = [];
  resultadoRubros: RubroResult[] = [];
  resultadoEmpresa: EmpresaResult[] = [];
  resultadoMediosPago: MediosPago[] = [];
  resultadoServiciosComercio: ServiciosComercio[] = [];
  //arrayMeses: Array<{ codigo: string, valor: string }> = [];
  arrayMeses = [
    { codigo: 'Enero', valor: '01' },
    { codigo: 'Febrero', valor: '02' },
    { codigo: 'Marzo', valor: '03' },
    { codigo: 'Abril', valor: '04' },
    { codigo: 'Mayo', valor: '05' },
    { codigo: 'Junio', valor: '06' },
    { codigo: 'Julio', valor: '07' },
    { codigo: 'Agosto', valor: '08' },
    { codigo: 'Septiembre', valor: '09' },
    { codigo: 'Octubre', valor: '10' },
    { codigo: 'Noviembre', valor: '11' },
    { codigo: 'Diciembre', valor: '12' },
  ];
  arrayAnios: Array<{ codigo: string, valor: number }> = [];
  numberMonedaPipe: NumberMonedasStr = new NumberMonedasStr();

  @ViewChild(MatHorizontalStepper, { static: false }) myStepper: MatHorizontalStepper;
  showEspera: boolean = false;

  constructor(
    private mandatoservice: MandatosExpressService,
    private service: CardinalCommerceService,
    private ngZone: NgZone,
    public dialog: MatDialog,
    private loader: LoaderBaseService,
    public domSanitizer: DomSanitizer,
    private elementRef: ElementRef,
    public datepipe: DatePipe,
    private placeToPayService: PlaceToPayService,
    @Inject('env') private environment: any,
    private autenticatorService: AutenticadorService,
    private router: Router,
    private activeRoute: ActivatedRoute
  ) {
    this.estilos.cambioEstilos(this.elementRef);
  }

  ngOnInit() {
    this.loader.hide();
    this.isEmbebido = false;
    this.utilizaPromotor = false;
    this.firstFormGroup.controls['medioPagoAdquirente'].disable();
    this.firstFormGroup.controls['servicioComercio'].disable();
    this.firstFormGroup.get('idServicio').setValue('');
    this.firstFormGroup.get('codSeg').setValue('');

    this.urlSalida = '';
    this.idSesion = '';
    this.activeRoute.queryParams.subscribe(params => {

      let url = '';
      if(params['url']){
        url = params['url'];
        const encode1 = decodeURIComponent(url);
        this.urlSalida = decodeURIComponent(encode1);
      }

      if(params['sesion']){
        this.idSesion = params['sesion'];
        this.validaSesion();
        this.embebidoData();
        this.isEmbebido = true;
      }else{
        this.preLoginsWait();
      }
    });

    this.setListAnios();
    //this.setListCiudades();
    //this.setListMeses();

    window['angularComponentReference'] = { component: this, zone: this.ngZone, loadAngularFunction: () => this.responsePlace2Pay() };
  }

  validaSesion(){
    this.peticionSesion.token = this.idSesion;
    this.autenticatorService.postValidaSesion(this.peticionSesion).subscribe(data => {
      if('0' != data.codret){
        //TODO Arreglar
        //sessionStorage.setItem('preLoginError', JSON.stringify(data));
        //this.router.navigate(['/mantencion']);
      }
    });
  }

  embebidoData(){
    sessionStorage.setItem("date", Date());
    this.embebido.uuid = this.idSesion;
    sessionStorage.setItem('sesionIdSesion', this.embebido.uuid);

    this.autenticatorService.postApiLoginEmb(this.embebido).subscribe(data => {
      if(data.codret != '0'){
        sessionStorage.setItem('preLoginError', JSON.stringify(data));
        this.router.navigate(['/mantencion']);
      }else{
        if (data.estadoPortal == 'SUSPENDIDO') {
          sessionStorage.setItem('preLoginError', JSON.stringify(data));
          this.router.navigate(['/mantencion']);
        }else{
          sessionStorage.setItem('preLogin', JSON.stringify(data));
          sessionStorage.setItem('ambiente',data['codTpoPortal']);
          sessionStorage.setItem('userPerfil', JSON.stringify(data));

          sessionStorage.setItem('docUsuario', data['usuario']['emailUsuario'].toString());
          sessionStorage.setItem('idPerfil', data['perfil']['idPerfil'].toString());
          sessionStorage.setItem('currentUser', JSON.stringify(data['usuario']));
          sessionStorage.setItem('tokenSession', data['tokenSession']);
          sessionStorage.setItem('minExpSession', data['perfil']['polMinExpSesion'].toString());

          this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
          this.setDatosUsuarioDefault();
          this.postApiDataComercio();
          this.postSentRubrosServices();
          this.estilos.cambioEstilos(this.elementRef);
          this.preLoginsLS = JSON.parse(sessionStorage.getItem('preLogin'));
          this.idUsuario = this.userPerfil.usuario.idUsuario;
        }
      }
   }, error => {
      console.error('error: ', error);
      sessionStorage.setItem('preLoginError', JSON.stringify(error));
      this.router.navigate(['/mantencion']);
   });
  }

  setDatosUsuarioDefault(){
    this.firstFormGroup.get('nombreSuscriptor').setValue(this.userPerfil.usuario.nomUsuario);
    this.firstFormGroup.get('apellidoA').setValue(this.userPerfil.usuario.apePatUsuario);
    this.firstFormGroup.get('apellidoB').setValue(this.userPerfil.usuario.apeMatUsuario);
    this.firstFormGroup.get('contactoEmail').setValue(this.userPerfil.usuario.emailUsuario);

    if (this.userPerfil.usuario.movilUsuario != null) {
      let movilUsuario: string = this.userPerfil.usuario.movilUsuario;
      this.firstFormGroup.get('codmovil').setValue(movilUsuario.substring(0, 3));
      this.firstFormGroup.get('contactoMovil').setValue(movilUsuario.substring(3, movilUsuario.length));
    }
    if (this.userPerfil.usuario.direccion != null) {
      this.firstFormGroup.get('contactoDireccion').setValue(this.userPerfil.usuario.direccion);
    }
  }

  postApiDataComercio() {
    this.firstFormGroup.controls['servicioComercio'].enable();

    this.firstFormGroup.controls['medioPagoAdquirente'].disable();
    this.firstFormGroup.controls['idRubro'].disable();
    this.sesionId.sesion_id_ses = this.idSesion;
    this.sesionId.codCliente = this.environment.codCliente;

    this.mandatoservice.postDatosEmbebido(this.sesionId).subscribe(data => {
      this.esComercio = true;

      this.firstFormGroup.get('rutSuscriptor').setValue(data['doc_id_usr_emp']);
      this.firstFormGroup.get('nombreSuscriptor').setValue(data['nom_usr_emp']);
      this.firstFormGroup.get('apellidoA').setValue(data['pat_usr_emp']);
      this.firstFormGroup.get('apellidoB').setValue(data['mat_usr_emp']);

      this.firstFormGroup.get('contactoEmail').setValue(data['eml_usr_emp']);

      this.firstFormGroup.get('codmovil').setValue(this.setCodTelefono(data['mvl_usr_emp']));
      this.firstFormGroup.get('contactoMovil').setValue(this.setNumTelefono(data['mvl_usr_emp']));
      this.firstFormGroup.get('contactoDireccion').setValue(data['dir_usr_emp']);

      this.resultadoServiciosComercio = data['servicios'];

      for(let i=0; i < data['servicios'].length; i++){
        let ids_default = data['servicios'][i]['ids_default'];
        this.servicios.push({name: data['servicios'][i]['ids_usr_ids'], value: data['servicios'][i]['dsc_usr_ids']})
        if(ids_default == 'D'){
          this.firstFormGroup.get('servicioAlias').setValue(data['servicios'][i]['dsc_usr_ids']);
          this.firstFormGroup.get('servicioComercio').setValue(data['servicios'][i]['ids_usr_ids']);
          this.firstFormGroup.get('idServicio').setValue(data['servicios'][i]['ids_usr_ids']);
        }

        if(i == 0){
          let idFacturador = data['servicios'][i]['id_facturador'];
          this.idFac = idFacturador;
          this.peticionListPacParametro.idFacturador = Number(idFacturador);
          this.idConvenioSelected = data['servicios'][i]['codConvenio'];
          this.peticionListPacParametro.idConvenio = this.idConvenioSelected;
          this.postPacParametroListarServices(this.peticionListPacParametro);
          let mtoMax = data['servicios'][i]['ids_mto_max'];
          if(mtoMax != '0'){
            this.firstFormGroup.get('medioPagoMontoMax').setValue(mtoMax);
          }
          let rbrCod = data['servicios'][i]['rbr_cod'];
          this.firstFormGroup.get('idRubro').setValue(rbrCod);

          this.peticionEmpresa.codRubro = rbrCod;
          this.peticionEmpresa.codCliente = this.environment.codCliente;
          this.peticionEmpresa.codEstadoConvenio = 'HBL';
          this.peticionEmpresa.codEstadoEmpresa = 'ACTIVO';
          this.postSentEmpresaServices(this.peticionEmpresa);
          if(this.tipoCobro!='F'){
            this.firstFormGroup.get('diaPago').setValue('0');
          }
          this.firstFormGroup.get('idEmpresa').setValue(Number(idFacturador));

          this.rubroSelectedOptiontText = data['servicios'][i]['rbr_desc'];
          this.empresaSelectedOptiontText = data['servicios'][i]['raz_soc_emp'];

        }

      }
    });
  }

  responsePlace2Pay() {
    this.dialog.closeAll()
    let docEmpresa: string = this.resultadoEmpresa.find(x => x.idFacturador == Number.parseInt(this.firstFormGroup.get('idEmpresa').value)).docFacturador;
    const placeToPayEntry: PlaceToPayPeticion = {
      codCliente: this.environment.codCliente,
      docEmpresa: docEmpresa,
      transactionID: this.transactionID.toString()
    }
    this.placeToPayService.getTransaction(placeToPayEntry).subscribe((resp: PlaceToPayGetTransaResponse) => {
      if (resp.codret === '0') {
        let estadoTrx = resp.transStatus;
        if (estadoTrx === 'Y') {
          this.saveMandato();
        } else {
          this.showDialog('Error', 'Error en validaci&oacute;n, intente nuevamente.', false, 'Cancelar', 'Aceptar');
        }
      } else {
        this.showDialog('Error', 'Error al llamar servicio de validaci&oacute;n, intente nuevamente.', false, 'Cancelar', 'Aceptar');
      }
    }, (error: any) => {
      console.error('error', error);
      this.showDialog('Error', 'Error al llamar servicio de validaci&oacute;n, intente nuevamente.', false, 'Cancelar', 'Aceptar');
    })
  }

  onServicioSelect(event:any){
    this.firstFormGroup.get('idServicio').setValue(event.value);
    this.firstFormGroup.controls['medioPagoAdquirente'].disable();

    for(let x = 0; x < this.servicios.length; x++){
      if(this.servicios[x].name == event.value){
        this.firstFormGroup.get('servicioAlias').setValue(this.servicios[x].value);
      }
    }
  }

  onTarjetaSelect(event:any){
    let fecha = this.resultadoMediosPago.find(x => x.pan_usr_medpag == event.value).fec_exp_usr_medpag;
    let mes = fecha.substring(0,2);
    let anho = fecha.substring(2,4);

    this.firstFormGroup.get('medioPago').setValue(event.value);
    this.firstFormGroup.get('mesMedioPago').setValue(mes);
    this.firstFormGroup.get('anioMedioPago').setValue(anho);

    this.getCardBrand(event.value);
  }

  getCardBrand(cardPan: string) {

    if (this.firstFormGroup.get('medioPago').valid) {

      let bin8digits = cardPan.substring(0, 8);
      let params: ConsultaBinParams = new ConsultaBinParams();
      params.bin = bin8digits;

      this.loader.show();

      this.cardBrand = 'UNKNOW';

      this.service.consultaBin(params, this.isEmbebido).subscribe((data: ConsultaBinResponse) => {
        if (data.codret == '0') {
          if (data.binIso2Pais == this.environment.binIsoPais && (data.binTipoTarjeta == 'CREDIT' || data.binTipoTarjeta == 'DEBIT')) {
            if (data.binMarca == 'AMEX') {
              this.imgtarjeta = "amex";
              this.cardBrand = 'AMEX';
            } else if (data.binMarca == 'MASTERCARD') {
              this.imgtarjeta = "mastercard";
              this.cardBrand = 'MASTERCARD';
            } else if (data.binMarca == 'MAESTRO') {
              this.imgtarjeta = "maestro";
              this.cardBrand = 'MAESTRO';
            } else if (data.binMarca == 'VISA') {
              this.imgtarjeta = "visa";
              this.cardBrand = 'VISA';
            } else {
              this.imgtarjeta = "unknow";
              this.cardBrand = 'UNKNOW'
            }
            this.loader.hide();
          } else {
            this.firstFormGroup.controls['medioPago'].reset('', { onlySelf: false, emitEvent: false });
            this.showDialog('Error', 'S&oacute;lo se admiten tarjetas de d&eacute;bito y cr&eacute;dito nacionales.', false, 'Cancelar', 'Aceptar');
            this.loader.hide();
          }
        } else {
          this.firstFormGroup.controls['medioPago'].reset('', { onlySelf: false, emitEvent: false });
          this.showDialog('Error', 'S&oacute;lo se admiten tarjetas de d&eacute;bito y cr&eacute;dito nacionales.', false, 'Cancelar', 'Aceptar');
          this.loader.hide();
        }
      }, err => {
        console.error('error: ', err);
        this.firstFormGroup.controls['medioPago'].reset('', { onlySelf: false, emitEvent: false });
        this.showDialog('Error', 'Error al realizar validaci&oacute;n de bin de tarjeta, intente nuevamente.', false, 'Cancelar', 'Aceptar');
        this.loader.hide();
      });
    }

  }

  validarSubscripcion() {
    if (this.confirmacionForm.valid) {
      //Dialogos
      this.showDialog('Información:', 'Con el fin de autenticar la inscripci&oacute;n de tu PAR,<br>realizaremos una transacci&oacute;n de validaci&oacute;n,<br>la cual no presentar&aacute; cargos en tu tarjeta.<br>¿Autorizas esta transacci&oacute;n?', true, 'No Acepto', 'Si, Acepto');
    } else {
      this.showDialog('Error', 'Debe aceptar las condiciones de uso antes de continuar.', false, 'Cancelar', 'Aceptar');
    }
  }

  consultaPlaceToPay() {
    let docEmpresa: string = this.resultadoEmpresa.find(x => x.idFacturador == Number.parseInt(this.firstFormGroup.get('idEmpresa').value)).docFacturador;
    const placeToPayEntry: PlaceToPayPeticion = {
      acctNumber: this.firstFormGroup.get('medioPago').value,
      cardExpiryDate: this.firstFormGroup.get('anioMedioPago').value + this.firstFormGroup.get('mesMedioPago').value,
      purchaseAmount: (this.monedaPago == 'UYU') ? '50.0' : '1.0',
      purchaseCurrency: this.monedaPago,
      redirectURI: this.environment.urlAmbiente + '/apiTransaccionMT/validateTrxPlace2Pay',
      codCliente: this.environment.codCliente,
      docEmpresa: docEmpresa
    }

    this.placeToPayService.getTokenPlace2PaySession(placeToPayEntry, this.isEmbebido).subscribe((respPlaceToPay: PlaceToPayResponse) => {
      if (respPlaceToPay.codret === '0') {
        this.transactionID = parseInt(respPlaceToPay.transactionID)
        const dialogRef = this.dialog.open(DialogPlace2payComponent, {
          data: { url: respPlaceToPay.redirectURL },
          panelClass: 'dialog-place-2-pay',
          disableClose: true
        });

        dialogRef.afterClosed().subscribe(resp => {
          if (resp === 'cerrarModal') this.responsePlace2Pay()
        })

      } else if (respPlaceToPay.codret === '-1') {
        this.saveMandato();
      } else {
        this.showDialog('Error', 'Error al llamar servicio de validaci&oacute;n, intente nuevamente.', false, 'Cancelar', 'Aceptar');
      }
    }, (error: any) => {
      this.showDialog('Error', 'Error al llamar servicio de validaci&oacute;n, intente nuevamente.', false, 'Cancelar', 'Aceptar');
      console.error('error: ', error);
    })
  }

  generateSecure3DSPlace2Pay(cardBrand: string, eciFlag: string, threeDSVersion: string, dSTransactionId: string, uCAFIndicator: string, cavvIn: string) {
    let eciflag = eciFlag;
    let version = '0' + threeDSVersion.substring(0, 1);
    let cavv = cavvIn + '                                        '; //40
    let dsTrxId = dSTransactionId + '                                        ';//40
    let ucafIndicator = uCAFIndicator;

    if (cardBrand == 'VISA' || cardBrand == 'AMEX') {
      return eciflag + version + cavv.substring(0, 40) + dsTrxId.substring(0, 40);
    } else if (cardBrand == 'MASTERCARD' || cardBrand == 'MAESTRO') {
      return eciflag + version + cavv.substring(0, 32) + dsTrxId.substring(0, 36) + ucafIndicator;
    } else {
      return 'UNKNOW';
    }
  }

  getCodFacturador(idFacturador:number){
    for (let index = 0; index < this.resultadoEmpresa.length; index++) {
      const empresa = this.resultadoEmpresa[index];
      if(empresa.idFacturador == idFacturador){
        return empresa.codFacturador;
      }
    }
  }

  validaMonto(str: string) {
    var newstr = (str).replace(/,/g, '').replace(/\./g, '');
    if (newstr) {
      newstr = (Number.parseInt(newstr) * 100).toString();
    }
    return newstr;
  }

  validFormulario() {
    if(this.firstFormGroup.valid) {
      if(!this.utilizaPromotor){
        this.firstFormGroup.get('nombrePromotor').setValue('');
      }
      this.terminoCondicionesParam();
      this.myStepper.next();
    }else{
      this.markInvalidFileds();
    }
  }

  markInvalidFileds(){
    for(const filed in this.firstFormGroup.controls){
      const control=this.firstFormGroup.get(filed);
      if(control.invalid){
        //console.log(`El campo "${filed}" es inválido. Errores: `, control.errors);
      }
    }
  }

  terminoCondicionesParam()  {
    this.terminoCond.idEmpresa = (this.esComercio ? "" + this.firstFormGroup.get('idEmpresa').value : "" + this.firstFormGroup.get('idEmpresa').value.split(',')[0]);
    this.terminoCond.rut = this.firstFormGroup.get('rutSuscriptor').value;
    this.terminoCond.nombre = this.firstFormGroup.get('nombreSuscriptor').value;
    this.terminoCond.primerApellido = this.firstFormGroup.get('apellidoA').value;
    this.terminoCond.segundoApellido = this.firstFormGroup.get('apellidoB').value;
    this.terminoCond.tarjeta = this.firstFormGroup.get('medioPago').value;
    this.terminoCond.tarjetaTipo = this.imgtarjeta.toUpperCase();
    this.terminoCond.fechaVctoTarjeta = this.firstFormGroup.get('mesMedioPago').value + "/" + this.firstFormGroup.get('anioMedioPago').value;
    let fechaHoy = new Date();
    this.terminoCond.fechaSubscripcion = this.datepipe.transform(fechaHoy, 'dd/MM/yyyy');
    this.terminoCond.idServicio = this.firstFormGroup.get('idServicio').value;
  }

  saveMandato() {
    this.mandato.idRecaudador = '-1';
    this.mandato.idEmpresa = (this.esComercio ? this.firstFormGroup.get('idEmpresa').value : this.firstFormGroup.get('idEmpresa').value.split(',')[0]);
    this.mandato.rutSuscriptor = this.firstFormGroup.get('rutSuscriptor').value;
    this.mandato.nombreSuscriptor = this.firstFormGroup.get('nombreSuscriptor').value;
    this.mandato.apellido1Suscriptor = this.firstFormGroup.get('apellidoA').value;
    this.mandato.apellido2Suscriptor = this.firstFormGroup.get('apellidoB').value;
    this.mandato.idServicioEmpresa = this.firstFormGroup.get('idRubro').value;
    this.mandato.idFacturador = (this.esComercio ? this.firstFormGroup.get('idEmpresa').value : this.firstFormGroup.get('idEmpresa').value.split(',')[0]);
    this.mandato.idServicio = this.firstFormGroup.get('idServicio').value;
    this.mandato.servicioAlias = this.firstFormGroup.get('servicioAlias').value;

    this.mandato.medioPago = this.firstFormGroup.get('medioPago').value;
    this.mandato.tipoMedioPago = this.cardBrand;

    this.mandato.mesMedioPago = this.firstFormGroup.get('mesMedioPago').value;
    this.mandato.anioMedioPago = this.firstFormGroup.get('anioMedioPago').value;
    this.mandato.codSeg = (this.firstFormGroup.get('codSeg').value != '' ? this.firstFormGroup.get('codSeg').value : '000');

    this.mandato.idcomercio = (this.esComercio ? this.getCodFacturador(this.firstFormGroup.get('idEmpresa').value) : this.getCodFacturador(this.firstFormGroup.get('idEmpresa').value.split(',')[0]));

    if (this.tipoCobro == 'V') {
      let medioPagoMontoMax: string = this.firstFormGroup.get('medioPagoMontoMax').value;
      medioPagoMontoMax = (medioPagoMontoMax != null && medioPagoMontoMax != '' && medioPagoMontoMax != undefined ? CustomValidators.validaMonto(medioPagoMontoMax) : '0');
      this.mandato.medioPagoMontoMax = (this.monedaPago == 'UYU' ? (parseInt(medioPagoMontoMax) * 100).toString() : medioPagoMontoMax);
      this.firstFormGroup.get('montofijo').disable();
      this.mandato.montofijo = '0';
      this.mandato.diaPago = '0';
    } else {
      let montofijo: string = this.firstFormGroup.get('montofijo').value;
      montofijo = (montofijo != null && montofijo != '' && montofijo != undefined ? CustomValidators.validaMonto(montofijo) : '0');
      this.mandato.montofijo = (this.monedaPago == 'UYU' ? (parseInt(montofijo) * 100).toString() : montofijo);
      this.firstFormGroup.get('medioPagoMontoMax').disable();
      this.mandato.diaPago = this.firstFormGroup.get('diaPago').value;
    }

    this.mandato.contactoEmail = this.firstFormGroup.get('contactoEmail').value;
    this.mandato.contactoFijo = "";

    let codmovil:string = this.firstFormGroup.get('codmovil').value;
    let fonomovil:string = this.firstFormGroup.get('contactoMovil').value;
    this.numeroMovilCompleto = codmovil + fonomovil;
    this.mandato.contactoMovil = this.numeroMovilCompleto;

    this.mandato.contactoDireccion = this.firstFormGroup.get('contactoDireccion').value;
    this.mandato.contactoCiudad = this.firstFormGroup.get('contactoCiudad').value;
    this.mandato.enviaMail = this.firstFormGroup.get('notificacionEmail').value ? "1" : "0";
    this.mandato.contactoNotificacion = "1";

    this.mandato.canal = 'express';
    this.mandato.idMandante = this.idUsuario;

    this.mandato.codCliente = this.environment.codCliente;
    this.mandato.docEmpresa = this.environment.docEmpresa;
    this.mandato.codTpoPortal = this.preLoginsLS.codTpoPortal;
    this.mandato.idConvenio = this.idConvenioSelected;
    this.mandato.nombrePromotor = this.firstFormGroup.get('nombrePromotor').value;
    this.mandato.tokenSuscripcion = "";
    this.mandato.trxmoneda = this.monedaPago;

    this.loader.hide();
    this.loader.show();

    this.mandatoservice.postAddMandato(this.mandato, this.isEmbebido).subscribe(result => {
      this.loader.hide();
      let codret: number = Number(result.codret);
      switch (codret) {
        case 0:
          this.isEditable = false;
          this.isCompleted = true;
          this.myStepper.selected.completed = true;
          this.myStepper.next();
          this.terminoCondFinal.idMandato = result.idMandato;
          this.terminoCondFinal.codTpoPortal = this.preLoginsLS.codTpoPortal;
          this.terminoCondFinal.idUsuario = ""+this.idUsuario;
          this.terminoCondFinal.empresa = this.environment.docEmpresa;
          break;
        case -3:
          this.showDialog('Error', 'Ya existe una cuenta suscrita para el id de servicio.', false, 'Cancelar', 'Aceptar');
        default:
          this.showDialog('Error', 'Ocurri&oacute; un error al suscribir mandato, intente nuevamente.', false, 'Cancelar', 'Aceptar');
      }
    }, error => {
      this.loader.hide();
      console.error('error: ', error);
      this.showDialog('Error', 'Ocurri&oacute; un error al suscribir mandato, comun&iacute;­quese con el administrador.', false, 'Cancelar', 'Aceptar');
    }
    )
  }


  postSentRubrosServices() {
    let params: RubroRequest = new RubroRequest();
    params.codEstadoConvenio = 'HBL';
    this.mandatoservice.postListaRubros(params, this.isEmbebido).subscribe(data => {
      if (data.codret == '0') {
        this.resultadoRubros = data.resultado;
      } else {
        this.showDialogError('Error', 'Ocurri&oacute; un error al listar los servicios.', false, 'Cancelar', 'Aceptar');
      }
    }, err => {
      console.error('error: ', err);
      this.showDialogError('Error', 'Ocurri&oacute; un error al listar los servicios.', false, 'Cancelar', 'Aceptar');
    });
  }

  postSentEmpresaServices(body: EmpresasPeticion) {
    this.mandatoservice.postListaEmpresas(body, this.isEmbebido).subscribe(data => {
      if (data.codret == '0') {
        this.resultadoEmpresa = data.resultado;
        if(this.esComercio){
          this.monedaPago = data.resultado[0].tipoMoneda;
          this.lengthMontoPorMoneda = this.monedaPago == 'USD' ? 13 : 10;
        }
        if(this.idFac != ''){
          this.buscarImagenes(this.idFac, this.idConvenioSelected);
        }
      } else {
      }
    }, err => {
      console.error('error: ', err);
    });
  }

  onRubroSelect(event: any) {
    this.firstFormGroup.controls['idEmpresa'].reset();
    this.firstFormGroup.controls['idServicio'].reset();

    this.peticionEmpresa.codRubro = event.value;
    this.peticionEmpresa.codCliente = this.environment.codCliente;
    this.peticionEmpresa.codEstadoConvenio = 'HBL';
    this.peticionEmpresa.codEstadoEmpresa = 'ACTIVO';
    this.postSentEmpresaServices(this.peticionEmpresa);

    this.firstFormGroup.controls['idEmpresa'].enable();
    this.firstFormGroup.controls['diaPago'].reset();
    this.tipoCobro = 'V';

    this.rubroSelectedOptiontText = event.source.selected._element.nativeElement.innerText.trim();
  }

  postPacParametroListarServices(body: ListPacParametroPeticion) {
    this.mandatoservice.postPacParametroListar(body, this.isEmbebido).subscribe(data => {
      if (data.codret == '0') {
        for (let index = 0; index < data.resultado.length; index++) {
          if (data.resultado[index].codigoParametro == 'DIAS_CARGO') {
            if (data.resultado[index].valorParametro != '') {
              this.resultadoListPacParametro = [];
              let valorParametroString = data.resultado[index].valorParametro;
              var valorParametroLista = valorParametroString.split(",");
              for (let index = 0; index < valorParametroLista.length; index++) {
                this.resultadoListPacParametro.push(valorParametroLista[index]);
              }
            }
          }
          if (data.resultado[index].codigoParametro == 'TIPO_COBRO') {
            if (data.resultado[index].valorParametro == 'F') {
              this.tipoCobro = 'F';
              this.firstFormGroup.controls['diaPago'].enable();
              this.firstFormGroup.controls['diaPago'].reset();
              this.firstFormGroup.get('montofijo').enable();
              this.firstFormGroup.get('medioPagoMontoMax').disable();
              this.firstFormGroup.get('montofijo').setValidators(Validators.compose([Validators.required, Validators.maxLength(this.lengthMontoPorMoneda), CustomValidators.amountValidator]));
            } else {
              this.tipoCobro = 'V';
              this.firstFormGroup.get('medioPagoMontoMax').enable();
              this.firstFormGroup.get('montofijo').disable();
              this.firstFormGroup.get('medioPagoMontoMax').setValidators(Validators.compose([Validators.maxLength(this.lengthMontoPorMoneda), CustomValidators.amountValidator]));
            }
          }

          if(data.resultado[index].codigoParametro == 'ETIQUETA_PROMOTOR'){
            this.utilizaPromotor = data.resultado[index].valorParametro != "";
            this.etiquetaPromotor = data.resultado[index].valorParametro;
            this.placeHolderPromotor = "Nombre de " + this.etiquetaPromotor;
          }
        }
      } else {
      }
    }, err => {
      console.error('error: ', err);
      this.showDialog('Error', 'Ocurri&oacute; un error al obtener la informaci&oacute;n de la empresa selecionada.', false, 'Cancelar', 'Aceptar');
    });
  }

  onEmpresaSelect(event: any) {
    this.firstFormGroup.controls['diaPago'].disable();
    let arSelect = event.value.split(",");
    this.peticionListPacParametro.idFacturador =arSelect[0];
    this.peticionListPacParametro.idConvenio = arSelect[2];
    this.utilizaPromotor = false;
    this.postPacParametroListarServices(this.peticionListPacParametro);

    this.idConvenioSelected = arSelect[2];
    this.monedaPago = arSelect[3];
    this.buscarImagenes(event.value, this.idConvenioSelected);
    this.firstFormGroup.get('medioPagoMontoMax').setValue('');
    this.firstFormGroup.get('montofijo').setValue('');
    this.lengthMontoPorMoneda = this.monedaPago == 'USD' ? 13 : 10;

    this.empresaSelectedOptiontText = event.source.selected._element.nativeElement.innerText.trim();
    this.firstFormGroup.controls['idServicio'].enable();
  }

  onCiudadSelect(event: any) {
    this.ciudadSelectedOptiontText = event.source.selected._element.nativeElement.innerText.trim();
  }

  myKeyup(event: any) {
    this.firstFormGroup.controls['medioPagoMontoMax'].setValue(event.target.value);
  }
  myKeyupFijo(event: any) {
    this.firstFormGroup.controls['montofijo'].setValue(event.target.value);
  }

  setListAnios() {
    let hoy = new Date();
    for (let i = 0; i < 20; i++) {
      let anio = (hoy.getFullYear() + i).toString();
      let anioValue = Number.parseInt((anio + "").substring(2, 4));
      this.arrayAnios.push({ codigo: anio, valor: anioValue });
    }
  }

  setListCiudades() {
    this.mandatoservice.listCiudadesReport().subscribe(data => {
      this.arrayCiudades = data.resultado;
    });
  }

  setListMeses() {
    for (let i = 1; i <= 12; i++) {
      let mes = i.toString();
      this.arrayMeses.push({ codigo: (mes.length == 1 ? '0' + mes : mes), valor: (mes.length == 1 ? '0' + mes : mes) });
    }
  }

  showDialog(pTitle: string, pContent: string, pShowBtnCancel: boolean, pBtnCancelar: string, pBtnAceptar: string) {
    const dialogRef = this.dialog.open(DialogBaseComponent, {
      data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel, btnCancelar: pBtnCancelar, btnAceptar: pBtnAceptar },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (pBtnCancelar == 'No Acepto' && 'false' == result.toString()) {
        //No Acepto
        const dialogRefReafirmatorio = this.dialog.open(DialogBaseComponent, {
          data: { title: pTitle, content: `Estimado Suscriptor: No es posible <br> continuar con el proceso de registro de tu <br> PAR. ¿Deseas continuar o salir del proceso de <br> suscripción de tu PAR?`, showBtnCancel: pShowBtnCancel, btnCancelar: 'Salir', btnAceptar: 'Continuar' },
          disableClose: true
        });

        dialogRefReafirmatorio.afterClosed().subscribe(result => {
          if ('true' == result.toString()) {
            //Continuar
            this.showDialog(pTitle, pContent, pShowBtnCancel, pBtnCancelar, pBtnAceptar);
          }
          this.loader.hide();
        });
      }
      if (pBtnAceptar == 'Si, Acepto' && 'true' == result.toString()) {
        //Si, Acepto
        this.consultaPlaceToPay()
        // this.validaFirstForm();
      }
    });
  }

  showCondicionesGenerales() {
    const dialogRef = this.dialog.open(CondicionesGeneralesComponent, {
      data: { terminoCondiciones : this.terminoCond , terminoCondicionesFinal : this.terminoCondFinal, isEmbebido: this.isEmbebido},
      disableClose: true,
      maxHeight: '550px'
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  formatearTelefono(event: any, campo: string) {
    let numero = event.target.value;
    if(numero == '' || numero == 'null') return;
    numero = numero.trim();
    let sep = ' ';

    let len = numero.length;
    let numeroFormato = numero;

    if (len <= 10) {
      numeroFormato = numero.replace(/(\d{1,3})(\d{3})(\d{4})/, '$1' + sep + '$2' + sep + '$3');
    }
    else if(len >10){
      numeroFormato = numero.replace(/(\d+)(\d{3})(\d{3})(\d{4})/, '$1' + sep + '$2' + sep + '$3' + sep + '$4');
    }
    if (campo == 'movil'){
      this.firstFormGroup.get('contactoMovil').setValue(numeroFormato);
    }

  }

  setCodTelefono(numero:string){
    let codigo:string = '';
    if(numero != null){
      if(numero.length != 0)
        codigo = (numero == 'null') ? '' : numero.substring(0,3);
    }
    return codigo;
  }

  setNumTelefono(numero:string){
    let numeroaparte:string = ''; 
    if(numero != null){
      if(numero.length != 0)
        numeroaparte = (numero == 'null') ? '' : numero.substring(3);
    }
    return numeroaparte;
  }

  ngOnDestroy() {
    sessionStorage.removeItem('componenteHijo');
    sessionStorage.removeItem('tokenSessionParExpress');
  }

  buscarImagenes(idFact:string, idConvenio: string){

    let docFacturador:string =  this.resultadoEmpresa.find(x => x.idFacturador == Number.parseInt(idFact)).docFacturador;
    //let idConvenio:string =  this.resultadoEmpresa.find(x => x.idFacturador == Number.parseInt(idFact)).idConvenio;

    this.buscarImagen.imgTpo="boleta";
    this.buscarImagen.cnv=idConvenio;
    this.buscarImagen.emp=docFacturador;
    this.buscarImagen.clt=this.environment.codCliente;
    this.mandatoservice.postBuscarImagenBoleta(this.buscarImagen, this.isEmbebido).subscribe(data => {
      if (data.codret == '0') {
        this.tieneImagen = true;
        this.imagenBoleta = data.img64;
        this.formatoImagenBoleta = data.imgFormat;
        this.base64Image = this.domSanitizer.bypassSecurityTrustResourceUrl('data:'+this.formatoImagenBoleta+';base64,' + this.imagenBoleta);
      }else{
        this.tieneImagen = false;
      }
    }, err => {
      console.log("error " + err);
    });;
  }

  valorSelectEmpresa(param1: string, param2: string) {
    return param2 == "" ? param1 : param1 + ": " + param2;
  }

  onMovilSelect(){
    this.firstFormGroup.get('codmovil').updateValueAndValidity();
    this.firstFormGroup.get('contactoMovil').updateValueAndValidity();

    let codmovil: string = this.firstFormGroup.get('codmovil').value;
    let fonomovil: string = this.firstFormGroup.get('contactoMovil').value;
    if (codmovil.length > 0 && fonomovil.length == 0) {
      this.firstFormGroup.get('contactoMovil').markAsTouched();
      this.firstFormGroup.get('contactoMovil').setErrors({ 'required': true });
    } else {
      if (codmovil.length == 0 && fonomovil.length > 0) {
        this.firstFormGroup.get('codmovil').markAsTouched();
        this.firstFormGroup.get('codmovil').setErrors({ 'required': true });
      }
    }
  }

  onMontoFijoSelect() {
    this.firstFormGroup.get('montofijo').updateValueAndValidity();
    let montofijo: string = this.firstFormGroup.get('montofijo').value;
    montofijo = (montofijo != null && montofijo != '' && montofijo != undefined ? CustomValidators.validaMonto(montofijo) : '0');

    if (montofijo == '0') {
      this.firstFormGroup.get('montofijo').setErrors({ 'amountError': true });
    }
  }

  preLoginsWait(){
    let params: PreLoginPeticion = new PreLoginPeticion();
    params.codCliente = environment.codCliente;
    params.urlPortal = environment.urlPortal;

    this.autenticatorService.preLogin(params).subscribe(data => {
      if (data.codret == '0') {
        sessionStorage.setItem('preLogin', JSON.stringify(data));
        sessionStorage.setItem('tokenSession', data.tokenSession);

        this.preLoginsLS = JSON.parse(sessionStorage.getItem('preLogin'));

        this.configParExpress();
      } else {
        this.showDialogError('Error', 'Ocurri&oacute; un error interno.', false, 'Cancelar', 'Aceptar');
      }
    }, error => {
      sessionStorage.setItem('preLoginError', JSON.stringify(error));
      this.router.navigate(['/mantencion']);
    });
  }

  configParExpress() {
    this.autenticatorService.getLoginPar().subscribe(data => {
      if (data.codret == '0') {
        sessionStorage.setItem('tokenSessionParExpress', data['tokenSession']);
        this.postSentRubrosServices();
      } else {
        this.showDialogError('Error', 'Ocurri&oacute; un error interno.', false, 'Cancelar', 'Aceptar');
      }
    }, err => {
      console.error('error: ', err);
    });
  }

  redirigirUsuario() {
    if (this.urlSalida !== '') {
      window.location.href = this.urlSalida;
    } else {
      this.router.navigate(['/inicio']);
    }
  }

  showDialogError(pTitle: string, pContent: string, pShowBtnCancel: boolean, pBtnCancelar: string, pBtnAceptar: string) {
    const dialogRef = this.dialog.open(DialogBaseComponent, {
      data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel, btnCancelar: pBtnCancelar, btnAceptar: pBtnAceptar},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.router.navigate(['/inicio']);
      }
    });
  }

}
